import { CHARACTERS } from 'src/constants/characters'
import AvatarDefault from 'src/assets/img/message/avatar-6.svg'

export const renderAvatar = (avatar, name) => {
  if (avatar) return avatar
  const character = CHARACTERS.find((item) => item.name === name)
  return character ? character.avatar : AvatarDefault
}
